const Home = () => {
  return <div>Welcome home</div>;
};

export default Home;
